/**
 * Axios client configuration and setup
 * Provides a configured axios instance with interceptors for authentication and error handling
 */

import axios from 'axios'

// Create axios instance
const client = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || 'http://localhost:3100/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
})

/**
 * Request interceptor - adds authorization header if token exists
 */
client.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

/**
 * Response interceptor - handles errors and token expiration
 */
client.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    // Handle 401 Unauthorized - token expired or invalid
    if (error.response?.status === 401) {
      localStorage.removeItem('token')
      // Optionally redirect to login page
      // window.location.href = '/login'
    }

    // Handle 429 Too Many Requests - rate limiting
    if (error.response?.status === 429) {
      console.warn('Request rate limited')
    }

    return Promise.reject(error)
  }
)

export default client
